import { expValEquals } from '@atlassian/jira-feature-experiments';
import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils';
import type { DepartmentOption } from './types';

const MARKETING_DEPARTMENT = 'marketing';
const HR_DEPARTMENT = 'hr';
const LEGAL_DEPARTMENT = 'legal';
const FINANCE_DEPARTMENT = 'finance';
const FACILITIES_DEPARTMENT = 'facilities';
const ANALYTICS_DEPARTMENT = 'analytics';
const SALES_DEPARTMENT = 'sales';
const IT_DEPARTMENT = 'it';
const BUSINESS_OPERATIONS = 'businessOperations';
const DESIGN_DEPARTMENT = 'design';
const CUSTOMER_SERVICE_DEPARTMENT = 'customerService';
const SOFTWARE_DEPARTMENT = 'software';
const MANUFACTURING_DEPARTMENT = 'manufacturing';
const RISK_COMPLIANCE_DEPARTMENT = 'riskAndCompliance';
const RESEARCH_DEPARTMENT = 'research';
const PROCUREMENT_DEPARTMENT = 'procurement';

export const OTHER_DEPARTMENT = 'other';

/**
 * NOTE: if adding new departmentType text here - add it to jira-components/jira-plugins/jira-servicedesk/sd-components/servicedesk/plugin/src/main/java/com/atlassian/servicedesk/internal/analytics/whitelist/DepartmentTypeWhitelist.java
 * in Jira Monolith as well. Otherwise, departmentType will not be sent in analytics event correctly ("Other" will be sent instead)
 * Or better yet, fetch these texts from BE, from single source of truth
 */
const departmentTypes: DepartmentOption[] = [
	{ icon: '📊', id: ANALYTICS_DEPARTMENT, isUGC: false },
	{ icon: '🔧', id: FACILITIES_DEPARTMENT, isUGC: false },
	{ icon: '💵', id: FINANCE_DEPARTMENT, isUGC: false },
	{ icon: '🤝', id: HR_DEPARTMENT, isUGC: false },
	{ icon: '⚖️', id: LEGAL_DEPARTMENT, isUGC: false },
	{ icon: '📨', id: MARKETING_DEPARTMENT, isUGC: false },
	{ icon: '🛒', id: SALES_DEPARTMENT, isUGC: false },
	{ icon: '💻', id: IT_DEPARTMENT, isUGC: false },
	{ icon: '⚙️', id: BUSINESS_OPERATIONS, isUGC: false },
	{ icon: '🎨', id: DESIGN_DEPARTMENT, isUGC: false },
	{ icon: '💙', id: CUSTOMER_SERVICE_DEPARTMENT, isUGC: false },
	{ icon: '🤖', id: SOFTWARE_DEPARTMENT, isUGC: false },
	{ icon: '🔩', id: MANUFACTURING_DEPARTMENT, isUGC: false },
	{ icon: '📋', id: RISK_COMPLIANCE_DEPARTMENT, isUGC: false },
	{ icon: '🔍', id: RESEARCH_DEPARTMENT, isUGC: false },
	{ icon: '📦', id: PROCUREMENT_DEPARTMENT, isUGC: false },
];

const departmentTypesWithoutBizOps: DepartmentOption[] = [
	{ icon: '📊', id: ANALYTICS_DEPARTMENT, isUGC: false },
	{ icon: '🔧', id: FACILITIES_DEPARTMENT, isUGC: false },
	{ icon: '💵', id: FINANCE_DEPARTMENT, isUGC: false },
	{ icon: '🤝', id: HR_DEPARTMENT, isUGC: false },
	{ icon: '⚖️', id: LEGAL_DEPARTMENT, isUGC: false },
	{ icon: '📨', id: MARKETING_DEPARTMENT, isUGC: false },
	{ icon: '🛒', id: SALES_DEPARTMENT, isUGC: false },
	{ icon: '💻', id: IT_DEPARTMENT, isUGC: false },
	{ icon: '🎨', id: DESIGN_DEPARTMENT, isUGC: false },
	{ icon: '💙', id: CUSTOMER_SERVICE_DEPARTMENT, isUGC: false },
	{ icon: '🤖', id: SOFTWARE_DEPARTMENT, isUGC: false },
	{ icon: '🔩', id: MANUFACTURING_DEPARTMENT, isUGC: false },
	{ icon: '📋', id: RISK_COMPLIANCE_DEPARTMENT, isUGC: false },
	{ icon: '🔍', id: RESEARCH_DEPARTMENT, isUGC: false },
	{ icon: '📦', id: PROCUREMENT_DEPARTMENT, isUGC: false },
];

const getDepartments = functionWithCondition(
	() => expValEquals('jsm_hr_remove_business_operations_team_type', 'cohort', 'variation'),
	() => departmentTypesWithoutBizOps,
	() => departmentTypes,
);

export const defaultDepartmentOptionsWithEmoji: DepartmentOption[] = getDepartments();

export const PROJECT_TEAM_TYPE_FREE_TEXT_MAX_LENGTH = 80;
